import { FormControl, FormLabel, MenuItem, TextField, useMediaQuery, useTheme } from '@mui/material';

type Props = {
  label?: string;
  value: string;
  options: any[];
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  error?: string;
  onChange: (value: string) => void;
};

const SelectField = ({
  label,
  value = '',
  options = [],
  fullWidth = true,
  required,
  disabled,
  error,
  onChange,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const actualFullWidth = isMobile ? true : fullWidth;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl variant="standard" fullWidth={actualFullWidth}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <TextField
        select
        value={value}
        label={''}
        fullWidth={actualFullWidth}
        margin="dense"
        required={required}
        size="small"
        disabled={disabled}
        error={error !== undefined}
        helperText={error}
        sx={{ marginTop: '0', padding: 0 }}
        onChange={handleChange}
        slotProps={{ select: { autoWidth: false } }}
      >
        {options.map((option) =>
          typeof option === 'string' ? (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ) : (
            <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
              {option.label || option.value}
            </MenuItem>
          ),
        )}
      </TextField>
    </FormControl>
  );
};

export default SelectField;
